var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"0px","position":"absolute","left":"-20px"}},[_c('img',{staticStyle:{"height":"0px"},attrs:{"src":_vm.$common.access_count + _vm.page_tag}})])}
var staticRenderFns = []

export { render, staticRenderFns }